import {useTranslation} from 'react-i18next';
import {Button, cn} from '@chekinapp/ui';

export type VerifyLaterLinkProps = {
  onClick: () => void;
  className?: string;
};

export function VerifyLaterLink({onClick, className}: VerifyLaterLinkProps) {
  const {t} = useTranslation('identity-verification');

  return (
    <Button
      variant="link"
      tone="quiet"
      onClick={onClick}
      className={cn('py-2', className)}
    >
      {t('verify_later')}
    </Button>
  );
}
